import { HubertBadge } from 'components/HubertUI/HubertBadge';
import type { ComponentProps } from 'react';
import type { TInterviewClass } from 'types/interview.types';

interface Props extends ComponentProps<typeof HubertBadge> {
  interview: TInterviewClass;
}

const InterviewState = ({ interview, ...props }: Props) => {
  if (interview.interviewEnded) {
    return (
      <HubertBadge {...props} variant={'success'}>
        Interview is ended
      </HubertBadge>
    );
  }

  if (interview.interviewStarted) {
    return (
      <HubertBadge {...props} variant={'warning'}>
        Interview is started
      </HubertBadge>
    );
  }

  if (interview.interviewLoaded) {
    return (
      <HubertBadge {...props} variant={'warning'}>
        Interview is loaded
      </HubertBadge>
    );
  }

  return (
    <HubertBadge {...props} variant={'danger'}>
      Interview not started
    </HubertBadge>
  );
};

export default InterviewState;
